import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const API_VERSION = 'v1'
const REQUEST_URL = `${process.env.REACT_APP_REQUEST_URL}/api/${API_VERSION}/venue`

export const getRecommendedVenuesByBudget = createAsyncThunk(
	'api/venue/getRecommendedVenuesByBudget',
	async (budget) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/get-recommended-venues-by-budget/${budget}`,
				{
					method: 'GET',
					credentials: 'include',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				}
			)
			const result = await res.json()
			return result
		} catch (err) {
			console.log(err.message)
		}
	}
)

const initialState = {
	recommendedVenues: [],
}

const venueSlice = createSlice({
	name: 'venue',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(
			getRecommendedVenuesByBudget.fulfilled,
			(state, { payload }) => {
				if (!payload || !payload.success) {
					return
				}

				state.recommendedVenues = payload.recommendedVenues
			}
		)
	},
})

export default venueSlice.reducer
